import { createSelector } from '@ngxs/store';
import { TableState } from './table.state';
import type { TableStateModel } from './table-state.model';
import type { PageInfo, Sort } from '../data/table-data-source';

export class TableStateSelectors {
  static getPagination(tableId: string): (state: TableStateModel<unknown>) => PageInfo {
    return createSelector(
      [TableState],
      (state: TableStateModel<unknown>): PageInfo =>
        state[tableId]?.pagination ?? {
          page: 1,
          size: 10,
        },
    );
  }

  static getSort<T>(tableId: string): (state: TableStateModel<T>) => Sort<T> | undefined {
    return createSelector(
      [TableState],
      (state: TableStateModel<T>): Sort<T> | undefined => state[tableId]?.sort,
    );
  }

  static getFilters<T>(tableId: string): (state: TableStateModel<T>) => unknown | undefined {
    return createSelector(
      [TableState],
      (state: TableStateModel<T>): unknown | undefined => state[tableId]?.filters,
    );
  }

  static getDisplayedColumns(
    tableId: string,
  ): (state: TableStateModel<unknown>) => string[] | undefined {
    return createSelector(
      [TableState],
      (state: TableStateModel<unknown>): string[] | undefined => state[tableId]?.displayedColumns,
    );
  }
}
